import { observer } from 'mobx-react-lite'
import type { ReactNode } from 'react'
import { ContainerHeader, type ActionItem } from 'shared/ui'
import { useAnalyticsLayoutContext } from 'pages/analytics/context/analyticsLayoutContext'
import { AnalyzeWithAiButton } from './AnalyzeWithAiButton'

interface IAnalyticsHeaderProps {
  title: ReactNode
  actions?: ActionItem[]
}

export const AnalyticsHeader = observer(({ title, actions }: IAnalyticsHeaderProps) => {
  const {
    pageLayoutStore: { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction },
  } = useAnalyticsLayoutContext()

  return (
    <ContainerHeader
      height={72}
      title={title}
      titleVariant={'heading-md'}
      titleIconProps={titleIconProps}
      actionIconTooltipProps={headerMenuTooltipIconProps}
      titleIconAction={headerMenuIconAction}
      paddingLeft={20}
      paddingRight={20}
      actionsGap={8}
      actionsProps={{
        actions: [{ buttonComponent: <AnalyzeWithAiButton /> }, ...(actions || [])],
        isButton: true,
      }}
    />
  )
})
